export default "__VITE_ASSET__CtO4r3Rr__"